module.exports = __webpack_public_path__ + "img/icon-ayaka.e1beace5.webp";